export default "__VITE_ASSET__7cab9a07__"